import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template"
import {filterUser_template} from "./filterUser_template";
import {filterArticle_template} from "./filterArticle_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";


declare var ko: any;

export class transactionsVerificationList_template extends vnTemplate {

    protected pagination: pagination_template;
    protected dateFilter: filterDate_template;
    protected validationsList: validationsList_template;
    protected filterUser: filterUser_template;
    protected filterArticle: filterArticle_template;
    protected filterContentType: multipleSelector_template;
    protected filterKeywords: filterSimple_template;

    protected resultsInfos: resultsInfo_template;


    protected getTemplateHtml(): string {
        return `
           
            <div class="sub-header w-justify">
                
                <div class=" w-justify">
                    <div class="w-left">
                        ` + this.filterContentType.getHtmlBuild() + `            
                        ` + this.dateFilter.getHtmlBuild() + `
                    </div>
                </div>
                
            </div>
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-contentType"></div>
                </div>
            </div> 
            <div class="list-header w-justify" >
                <div class="w-left" >
                    <button class="btn secondary icon i-next" type="button" data-bind="css: { 'is-disable': editedFieldCount() == 0 }, event: { click : onApplyChanges }, text: 'Apply ' + editedFieldCount()  + ' Changes'">Apply</button>
                    
                </div>
                <div class="w-center">
                    ` + this.filterKeywords.getHtmlBuild() + `
                </div>
                <div class="w-right">
                    ` + this.pagination.getHtmlBuild() + `
                </div>
            </div>
            
            <div class="w-list-results"  data-bind="css: { loading: isLoading }">
               
                <table class="list-results">
                ` + this.resultsInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span></span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">Article ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Article Title</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'user') }, css: { 'list-sort-desc': orderByAndDirection()=='user_DESC', 'list-sort-asc': orderByAndDirection()=='user_ASC' }">User</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'contentType') }, css: { 'list-sort-desc': orderByAndDirection()=='contentType_DESC', 'list-sort-asc': orderByAndDirection()=='contentType_ASC' }">Content Type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'paymentCategory') }, css: { 'list-sort-desc': orderByAndDirection()=='paymentCategory_DESC', 'list-sort-asc': orderByAndDirection()=='paymentCategory_ASC' }">Payment Category</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalCommission') }, css: { 'list-sort-desc': orderByAndDirection()=='totalCommission_DESC', 'list-sort-asc': orderByAndDirection()=='totalCommission_ASC' }">Article Commission</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalTldrCommission') }, css: { 'list-sort-desc': orderByAndDirection()=='totalTldrCommission_DESC', 'list-sort-asc': orderByAndDirection()=='totalTldrCommission_ASC' }">TLDR Commission</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalPerformance') }, css: { 'list-sort-desc': orderByAndDirection()=='totalPerformance_DESC', 'list-sort-asc': orderByAndDirection()=='totalPerformance_ASC' }">Article Performance</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalBonus') }, css: { 'list-sort-desc': orderByAndDirection()=='totalBonus_DESC', 'list-sort-asc': orderByAndDirection()=='totalBonus_ASC' }">Total Bonus</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalTips') }, css: { 'list-sort-desc': orderByAndDirection()=='totalTips_DESC', 'list-sort-asc': orderByAndDirection()=='totalTips_ASC' }">Total Tips</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalHosting') }, css: { 'list-sort-desc': orderByAndDirection()=='totalHosting_DESC', 'list-sort-asc': orderByAndDirection()=='totalHosting_ASC' }">Total Hosting</span></th>
                            <th class="align-right total"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalAmount') }, css: { 'list-sort-desc': orderByAndDirection()=='totalAmount_DESC', 'list-sort-asc': orderByAndDirection()=='totalAmount_ASC' }">Total Amount</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: data">
                        <tr>
                            <td></td>
                            <td><span data-bind="text: id"></span></td>
                            <td><span data-bind="text: title"></span></td>
                            <td><span data-bind="text: user"></span></td>
                            <td><span data-bind="text: contentType"></span></td>

                            <td><span data-bind="text: paymentCategory"></span></td>
                            <td class="align-right">
                                <div class="w-cell">
                                    <span class="apply-icon icon i-next " data-bind="css: { 'is-edited': totalCommissionEdited() }" ></span>
                                    <input class="input-text" type="text" tabindex="0" data-bind="disable : disableInput(), textInput: totalCommission, css: {'read-only' : totalCommission() > 0 && !totalCommissionEdited()},  event: { keyup: $parent.onEditAmount.bind($data, 'commission')}, valueUpdate : 'afterkeydown'">
                                </div>
                            </td>
                            <td class="align-right">
                                <div class="w-cell">
                                    <span class="apply-icon icon i-next " data-bind="css: { 'is-edited': totalTldrCommissionEdited() }" ></span>
                                    <input class="input-text" type="text" tabindex="1" data-bind="disable : disableInput(), textInput: totalTldrCommission, css: {'read-only' : totalTldrCommission() > 0 && !totalTldrCommissionEdited()},  event: { keyup: $parent.onEditAmount.bind($data, 'tldr')}, valueUpdate : 'afterkeydown'">
                                </div>
                            </td>
                            <td class="align-right">
                                <div class="w-cell">
                                    <span class="apply-icon icon i-next " data-bind="css: { 'is-edited': totalPerformanceEdited() }"></span>
                                    <input class="input-text" type="text" tabindex="2" data-bind="disable : disableInput(), textInput: totalPerformance,css: {'read-only' : totalPerformance() > 0 && !totalPerformanceEdited()} ,event: { keyup: $parent.onEditAmount.bind($data, 'performance')}, valueUpdate : 'afterkeydown'">
                                </div>
                            </td>
                            <td class="align-right">
                                <div class="w-cell">
                                    <span class="apply-icon icon i-next " data-bind="css: { 'is-edited': totalBonusEdited() }"></span>
                                    <input class="input-text" type="text" tabindex="3" data-bind="disable : disableInput(), textInput: totalBonus,css: {'read-only' : totalBonus() > 0 && !totalBonusEdited()}, event: { keyup: $parent.onEditAmount.bind($data, 'bonus')}, valueUpdate : 'afterkeydown'">
                                </div>
                            </td>

                            <td class="align-right"><span data-bind="text: totalTips"></span></td>
                            <td class="align-right"><span data-bind="text: totalHosting"></span></td>
                            <td class="align-right total"><span data-bind="text: totalAmount"></span></td>
                        </tr>
                    </tbody>
                </table>
            
            </div>
            `;
    }

    protected initPartial(): void {

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        let currentDate = new Date();
        this.dateFilter = new filterDate_template("dateRangeFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.getTemplateViewModel().selectedFilter("range");
        this.dateFilter.setRange("-15d", "15d");

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);

        this.filterUser = new filterUser_template("filterUser", this.getTemplateViewModel(), this.caller);
        this.filterArticle = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);

        this.filterContentType = new multipleSelector_template("filterContentType", this.getTemplateViewModel(), this.caller);
        this.filterContentType.setLabel("content types");
        this.filterContentType.setFilterContainerClass('margin-neg');
        this.filterContentType.setTagContainerId('selected-contentType');
        this.filterContentType.setTagContainerCaption('Selected content type:');

        this.filterKeywords = new filterSimple_template("filterKeywords", this.getTemplateViewModel(), this.caller);
        this.resultsInfos = new resultsInfo_template("resultsInfo", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {
        return "transactionsVerificationList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected buildViewModel(): any {

        let self = this;
        return {
            orderBy: ko.observable("totalAmount"),
            orderByAndDirection: ko.observable("totalAmount_ASC"),
            orderByDirection: ko.observable("ASC"),
            editedFieldCount: ko.observable(0),
            data: ko.observableArray([]),
            isLoading: ko.observable(0),
            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            },
            onClickAdd: function () {
                self.onClickAdd();
            },
            onClickEdit: function (value, data, event) {
                self.onClickEdit(value, data, event);
            },
            onClickDelete: function (value, data, event) {
                self.onClickDelete(value, data, event);
            },
            onEditAmount: function (type, data, event) {
                self.onClickEditAmount(type, data, event);
            },
            onApplyChanges: function(data, event) {
                self.onApplyChanges();
            }
        };
    }

    public buildDatePickerCalendar() {

        this.dateFilter.buildCalendar();
    }

    public getViewModelForRequest() {

        return {
            list: {
                orderBy: this.getTemplateViewModel().orderBy,
                orderByDirection: this.getTemplateViewModel().orderByDirection,
                orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            },
            filterSimple: this.getTemplateViewModel().filterSimple,
            pagination: this.getTemplateViewModel().pagination
        }
    }

    public activateLoading() {

        this.getTemplateViewModel().isLoading(1);
    }

    public deactivateLoading() {

        this.getTemplateViewModel().isLoading(0);
    }

    public setData(data, companyId) {

        this.getTemplateViewModel().editedFieldCount(0);
        let newList = [];
        for (let item of data) {
            let newObj = {};
            for (let key of Object.keys(item)) {
                if (!isNaN(parseFloat(item[key])) && key != "id" && key != "totalAmount") {
                    newObj[key + "Edited"] = ko.observable(false);
                    newObj["default" + key] = ko.observable(item[key]);
                }
                if (key.includes("total")) {
                    newObj[key] = ko.observable(parseFloat(item[key]));
                } else {
                    newObj[key] = ko.observable(item[key]);
                }
            }
            newObj['disableInput'] = ko.observable(Number(companyId) != Number(item.idCompany));
            newList.push(newObj);
        }

        this.getTemplateViewModel().data(newList);
    }

    public setUsers(users) {

        this.getTemplateViewModel().filterUser.users(users);
    }

    public setArticles(articles) {

        this.getTemplateViewModel().filterArticle.articles(articles);
    }

    public setContentTypes(filterList: Array<{ id: number, name: string }>): void {

        this.filterContentType.setItems(filterList);
    }

    public onClickAdd() {

        this.caller.addTransaction();
    }

    public onClickEdit(value, data, event) {

        this.caller.editTransaction(value.id);
    }

    public onClickDelete(value, data, event) {

        this.caller.deleteTransaction(value.id);
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.transactionListReorder();
    }

    protected onUpdateError(requestStatus: any, responseParsed): void {

        let msg = "error: while obtaining the form data - (" + responseParsed.message + ")";
        this.validationsList.setSingleMessage({field: "error", "label": requestStatus, message: msg});
    }

    protected onClickEditAmount(type, data, e) {

        var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
        if ((keyCode >= 48 && keyCode <= 57) || keyCode == 8 || keyCode == 91 || keyCode == 93 ) {
            if (type == "commission") {
                if (parseFloat(data.totalCommission()) != parseFloat(data.defaulttotalCommission())) {
                    if (!data.totalCommissionEdited()) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) + 1)
                    }
                    data.totalCommissionEdited(true);
                } else {
                    if (data.totalCommissionEdited() && parseInt(this.getTemplateViewModel().editedFieldCount()) > 0) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) - 1)
                    }
                    data.totalCommissionEdited(false);
                }
            } else if (type == "tldr") {
                if (parseFloat(data.totalTldrCommission()) != parseFloat(data.defaulttotalTldrCommission())) {
                    if (!data.totalTldrCommissionEdited()) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) + 1)
                    }
                    data.totalTldrCommissionEdited(true);
                } else {
                    if (!data.totalTldrCommissionEdited() && parseInt(this.getTemplateViewModel().editedFieldCount()) > 0) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) - 1)
                    }
                    data.totalTldrCommissionEdited(false);
                }
            } else if (type == "performance") {

                if (parseFloat(data.totalPerformance()) != parseFloat(data.defaulttotalPerformance())) {
                    if (!data.totalPerformanceEdited()) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) + 1)
                    }
                    data.totalPerformanceEdited(true);
                } else {
                    if (data.totalPerformanceEdited() && parseInt(this.getTemplateViewModel().editedFieldCount()) > 0) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) - 1)
                    }
                    data.totalPerformanceEdited(false);

                }
            } else if (type == "bonus") {

                if (parseFloat(data.totalBonus()) != parseFloat(data.defaulttotalBonus())) {
                    if (!data.totalBonusEdited()) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) + 1)
                    }
                    data.totalBonusEdited(true);

                } else {
                    if (data.totalBonusEdited() && parseInt(this.getTemplateViewModel().editedFieldCount()) > 0) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) - 1)
                    }
                    data.totalBonusEdited(false)
                }
            } else if (type == "tips") {

                if (parseFloat(data.totalTips()) != parseFloat(data.defaulttotalTips())) {
                    if (!data.totalTipsEdited()) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) + 1)
                    }
                    data.totalTipsEdited(true);

                } else {
                    if (data.totalTipsEdited() && parseInt(this.getTemplateViewModel().editedFieldCount()) > 0) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) - 1)
                    }
                    data.totalTipsEdited(false)
                }
            } else if (type == "hosting") {

                if (parseFloat(data.totalHosting()) != parseFloat(data.defaulttotalHosting())) {
                    if (!data.totalHostingEdited()) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) + 1)
                    }
                    data.totalHostingEdited(true);
                } else {
                    if (data.totalHostingEdited() && parseInt(this.getTemplateViewModel().editedFieldCount()) > 0) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) - 1)
                    }
                    data.totalHostingEdited(false);
                }
            }
        }
        data.totalAmount(parseFloat(data.totalPerformance()) + parseFloat(data.totalTldrCommission()) + parseFloat(data.totalCommission()) + parseFloat(data.totalBonus()) + parseFloat(data.totalTips()) + parseFloat(data.totalHosting()));

    }

    public onApplyChanges(){

        this.caller.save(this.getTemplateViewModel().data);
    }

    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultsInfos.setExecutionTime(execTime);
        this.resultsInfos.setNbResults(nbResults);
        this.resultsInfos.setNbPages(nbPages);
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/transactionsVerificationList_template.ts